import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import queryString from 'query-string';

import BobHeader from '../components/BobHeader';
import Dashboard from './Dashboard/Dashboard';
import { getUserRoleByCompany, setPageTitle } from '../helpers/auth';
import { getApplicationName } from './Dashboard/Navigation/NavigationHelper';

import * as ArchitectActions from '../actions/architectActions';
import * as AttributeManagementActions from '../actions/attributeManagementActions';
import * as BobActions from '../actions/bobActions';
import * as CompanyManagementActions from '../actions/companyManagementActions';
import * as CoreActions from '../actions/coreActions';
import * as CurrentUserActions from '../actions/currentUserActions';
import * as DashboardActions from '../actions/dashboardActions';
import * as EquipmentTypeActions from '../actions/equipmentTypeActions';
import * as LookupActions from '../actions/lookupActions';
import { applicationTitles } from '../localization/en-us/applicationTitles';
import '@progress/kendo-theme-material/dist/all.css';

const Bob = ({
    activeNavCompany,
    allRoles,
    attributes,
    clearDashboardData,
    companyInfo,
    companies,
    currentUser,
    dashboardCurrentTimeStamp,
    dashboardTimePeriod,
    entities,
    fetchAllScopes,
    fetchApplications,
    fetchAttributes,
    fetchBusinessTypes,
    fetchBuildingTypes,
    fetchCurrentUserRole,
    fetchCustomAttributes,
    fetchEquipmentTypesLookup,
    fetchEquipmentManufacturers,
    fetchEnergyPrintIntegrations,
    fetchEntities,
    fetchSingleClient,
    fetchSingleEquipment,
    fetchSingleSite,
    fetchSources,
    fetchTechniciansList,
    fetchFuelTypes,
    fetchRawUnits,
    fetchSystemTypesLookup,
    firstTimeUser,
    history,
    progressBarLoading,
    setActiveNavClient,
    setActiveNavCompany,
    setActiveNavEquipment,
    setActiveNavSite,
    setAllRoles,
    setCompanyApplications,
    setCurrentScopes,
    setDashboardTimePeriod,
    setNavClient,
    setNavEquipment,
    setNavSite,
    targetNavCompany,
    ...props
}) => {
    useEffect(() => {
        return () => {
            setActiveNavCompany({});
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            setNavClient({});
            setNavSite({});
            setNavEquipment({});
        };
    }, []);

    //manage datepicker when switching apps
    useEffect(() => {
        const queryValues = queryString.parse(history.location.search);

        if (getApplicationName(queryValues.appId) !== 'energy') {
            if (dashboardTimePeriod === 'Previous7' || dashboardTimePeriod === 'Previous14') {
                setDashboardTimePeriod('Custom');
            }
        }
    }, [dashboardCurrentTimeStamp]);

    useEffect(() => {
        if (companies.length) {
            setAllRoles(companies);
        }
    }, [companies]);

    useEffect(() => {
        if (firstTimeUser) {
            history.push('/myaccount');
            return;
        }
    }, [currentUser]);

    useEffect(() => {
        if (companyInfo.companyId) {
            const updateScopes = async () => {
                const attributePayload = await fetchAttributes();
                const sourceAttribute = attributePayload.find(item => item.name === 'source');

                await fetchSources(companyInfo.companyId, sourceAttribute.id);
                await fetchEntities();
                await fetchCustomAttributes();

                Promise.all([
                    fetchBusinessTypes(),
                    fetchBuildingTypes(),
                    fetchEquipmentTypesLookup(),
                    fetchFuelTypes(),
                    fetchEquipmentManufacturers(),
                    fetchRawUnits(),
                    fetchSystemTypesLookup()
                ].map(p => p.catch(err => err)));

                let promises = [fetchAllScopes(companyInfo.companyId), fetchCurrentUserRole(companyInfo.companyId), fetchEnergyPrintIntegrations(companyInfo.companyId)];

                if (currentUser.isSuperUser) {
                    promises.push(fetchApplications());
                }

                await Promise.all(promises.map(p => p.catch(err => err)));

                const userRole = getUserRoleByCompany(allRoles, companyInfo.companyId);

                setCurrentScopes(userRole.scopes);
            };

            const { pathname } = history.location;
            const { companyId } = companyInfo;

            const queryValues = queryString.parse(history.location.search);
            
            if (!queryValues.company) {
                queryValues.company = companyId;
            }

            if (!isEmpty(queryValues.equipment)) {
                const equipmentOptions = {extendedData: true};
                fetchSingleEquipment(queryValues, equipmentOptions);
            } else if (!isEmpty(queryValues.site)) {
                fetchSingleSite(queryValues);
            } else if (!isEmpty(queryValues.client)) {
                fetchSingleClient(queryValues);
            }

            updateScopes();

            const queryValuesString = queryString.stringify(queryValues);

            history.push(`${pathname}?${queryValuesString}`);
        }
    }, [companyInfo]);

    useEffect(() => {
        if (activeNavCompany.id) setCompanyApplications(activeNavCompany.id);
    }, [activeNavCompany]);

    useEffect(() => {
        if (!isEmpty(activeNavCompany)) {
            //setPageTitle(applicationTitles.dashboard, activeNavCompany.name);
        } else if (isEmpty(activeNavCompany) && !isEmpty(targetNavCompany)) {
            setActiveNavCompany({...targetNavCompany});
            setPageTitle(applicationTitles.dashboard, targetNavCompany.name);
        }
    }, [activeNavCompany, targetNavCompany]);

    // useEffect(() => {
    //     if (targetNavCompany && targetNavCompany.name) {
    //         if (isEmpty(activeNavCompany)) {
    //             setPageTitle(applicationTitles.dashboard, targetNavCompany.name);
    //         }
    //     }
    // }, [history.location.search]);

    return (
        <React.Fragment>
            <BobHeader { ...props } />
            <Switch>
                <Route
                    path="/v2/dashboard"
                    render={(routeProps) => (
                        <Dashboard { ...routeProps } />
                    )}
                />
                {
                    process.env.executiveSummaryEnabled ?
                        <Redirect from="/v2" to="/v2/dashboard/executivesummary" />
                        :
                        <Redirect from="/v2" to="/v2/dashboard/company" />
                }
            </Switch>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany:          state.bob.activeNavCompany,
    allRoles:                  state.core.allRoles,
    attributes:                state.attributeManagement.attributes,
    companies:                 state.core.companies,
    companyInfo:               state.companyInfo,
    currentUser:               state.currentUser,
    dashboardCurrentTimeStamp: state.dashboard.dashboardCurrentTimeStamp,
    dashboardTimePeriod:       state.dashboard.dashboardTimePeriod,
    entities:                  state.attributeManagement.entities,
    progressBarLoading:        state.core.progressBarLoading,
    targetNavCompany:          state.bob.targetNavCompany,
});

const mapDispatchToProps = {
    ...ArchitectActions,
    ...AttributeManagementActions,
    ...BobActions,
    ...CompanyManagementActions,
    ...CoreActions,
    ...CurrentUserActions,
    ...DashboardActions,
    ...EquipmentTypeActions,
    ...LookupActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Bob));
